import { createContext } from 'react';

import type { MeterBarChartConsumerConfig } from '../types/meter-bar-chart-config.js';

/**
 * @internal
 */
export const MeterBarChartConfigContext = createContext<
  MeterBarChartConsumerConfig | string
>({});

/**
 * Provider for the meter bar chart configuration that can be shared across charts
 * @public
 */
export const MeterBarChartConfig = MeterBarChartConfigContext.Provider;
